import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { FormControl } from '@angular/forms';
import { take, takeUntil } from 'rxjs/operators';
import { ReplaySubject } from '@node_modules/rxjs';
import { Subject } from 'rxjs';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'app-control-selectlist',
  templateUrl: './control-selectlist.component.html',
  styleUrls: ['./control-selectlist.component.less'],
})
export class ControlSelectlistComponent
  extends AppComponentBase
  implements OnInit
{
  @ViewChild('controlsSelector', { static: true }) controlsSelector: MatSelect;
  @Input() compareWith: any;
  @Input() selectedValue: any;
  @Input() controlData: any;
  @Input() isReadOnly: any;
  selectionName: any;
  @Output()
  selectionChange: EventEmitter<any> = new EventEmitter<any>();
  public controlsFormCtrl: FormControl = new FormControl();
  public controlsFilterForm: FormControl = new FormControl();
  public filteredControls: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  protected _onDestroy = new Subject<void>();
  constructor(
    injector: Injector,
    private cdr: ChangeDetectorRef
  ) {
    super(injector);
  }

  ngOnInit(): void {
        setTimeout(() => {
            if(this.controlData) {

                this.controlsFormCtrl.setValue(this.controlData.options);
                this.filteredControls.next(this.controlData.options);

                if(this.controlData.dataSetEnabled && this.controlData.dropdownSearchEnabled) {
                    if(this.selectedValue && this.selectedValue.fieldValue) {
                        this.selectionName = this.selectedValue.fieldValue;
                    }
                } else {
                    this.selectionName = this.selectedValue ? this.selectedValue : '';
                }

                this.controlsFilterForm.valueChanges
                .pipe(takeUntil(this._onDestroy))
                .subscribe(() => {
                    this.filterControls();
                });

                this.cdr.detectChanges();
            }
        }, 1000);
  }

  selectControl(item) {
    this.selectionChange.emit(item);
    if(this.controlData.dataSetEnabled && this.controlData.dropdownSearchEnabled) {
        this.selectionName = item.display.fieldValue;
    } else {
        this.selectionName = item;
    }
  }

  protected filterControls() {
    if (!this.controlData && !this.controlData.options) {
      return;
    }

    let search = this.controlsFilterForm.value;
    if (!search) {
      this.filteredControls.next(this.controlData.options.slice());
      return;
    } else {
      search = search.toLowerCase();
    }

    if(this.controlData.dataSetEnabled) {
        this.filteredControls.next(
            this.controlData.options?.filter(
                (item) =>
                item.display.fieldValue.toLowerCase().indexOf(search) > -1
            )
        );
    } else {
        this.filteredControls.next(
            this.controlData.options?.filter(
                (item) =>
                item.display.toLowerCase().indexOf(search) > -1
            )
        );
    }
  }
}
